import { Link } from "react-router-dom";
import { Sparkles, ShieldCheck, Calendar, User } from "lucide-react";

function fmt(iso) {
  if (!iso) return "—";
  return new Date(iso).toLocaleDateString("en-US", { year: "numeric", month: "short", day: "numeric" });
}

export default function EditorialFooter({ entry }) {
  const cites = entry.citations || [];
  const verifiedCount = cites.filter((c) => c.verified).length;
  const verifiers = Array.from(new Set(cites.map((c) => c.verified_by).filter(Boolean)));
  return (
    <div className="mt-12 border-t border-black/15 pt-8" data-testid="editorial-footer">
      <div className="overline">/editorial transparency</div>
      <div className="mt-3 grid sm:grid-cols-2 gap-x-10 gap-y-3 text-sm">
        <Row icon={<User className="w-4 h-4" />} label="Drafted by" value={entry.created_by || "—"} extra={fmt(entry.created_at)} />
        <Row icon={<ShieldCheck className="w-4 h-4 text-[#0050FF]" />} label="Reviewed by" value={entry.reviewed_by || "—"} extra={fmt(entry.reviewed_at)} />
        <Row icon={<Calendar className="w-4 h-4" />} label="Published" value={fmt(entry.published_at)} />
        <Row icon={<ShieldCheck className="w-4 h-4 text-[#008A00]" />} label="Receipts verified" value={`${verifiedCount} of ${cites.length}`} extra={verifiers.length > 0 ? `by ${verifiers.join(", ")}` : null} />
      </div>
      {entry.ai_assisted && (
        <div className="mt-4 inline-flex items-center gap-2 px-3 py-1.5 bg-[#F0F4FF] border border-[#0050FF] text-[#0040cc]">
          <Sparkles className="w-3.5 h-3.5" />
          <span className="text-xs font-mono-plex uppercase tracking-wider">
            AI-assisted draft · reviewed by a human editor before publication
          </span>
        </div>
      )}
      <p className="mt-4 text-xs text-[#555] max-w-2xl">
        Every published entry passes through a human-review gate. Editors open every cited source, mark each citation as
        verified, and only then unlock the publish button. <Link to="/about" className="underline underline-offset-4 hover:text-black">Read our methodology →</Link>
      </p>
    </div>
  );
}

function Row({ icon, label, value, extra }) {
  return (
    <div className="flex items-start gap-2.5">
      <span className="mt-0.5 text-[#555] shrink-0">{icon}</span>
      <div>
        <div className="font-mono-plex text-[11px] uppercase tracking-[0.2em] text-[#555]">{label}</div>
        <div className="text-sm text-black mt-0.5">{value}</div>
        {extra && <div className="text-[11px] text-[#555] mt-0.5">{extra}</div>}
      </div>
    </div>
  );
}
